import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=ab64ec32&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"
import style0 from "./Culture.vue?vue&type=style&index=0&id=ab64ec32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab64ec32",
  null
  
)

export default component.exports